export const locale = {
  lang: 'es',
  data: {
    'HEADER': {
      'TITLE': 'Detalles de registro',
    },
  }
};
